import {
useEffect,
useState
} from "react";

import {
useNavigate,
useParams
} from "react-router-dom";

import API from "../../services/api";

function EditSupplier() {

const { id } =
useParams();

const navigate =
useNavigate();

const [form,
setForm] =
useState({
supplier_name: "",
phone: "",
email: "",
gst_no: "",
address: "",
status: 1
});

useEffect(() => {
loadSupplier();
}, []);

const loadSupplier =
async () => {

  try {

    const token =
      localStorage.getItem(
        "adminToken"
      );

    const res =
      await API.get(
        `/suppliers/${id}`,
        {
          headers: {
            Authorization:
              `Bearer ${token}`
          }
        }
      );

    setForm(
      res.data
    );

  } catch (err) {
    console.log(err);
  }

};

const handleChange =
(e) => {

  setForm({
    ...form,
    [e.target.name]:
      e.target.value
  });

};

const submit =
async (e) => {

  e.preventDefault();

  try {

    const token =
      localStorage.getItem(
        "adminToken"
      );

    await API.put(
      `/suppliers/${id}`,
      form,
      {
        headers: {
          Authorization:
            `Bearer ${token}`
        }
      }
    );

    navigate(
      "/admin/suppliers"
    );

  } catch (err) {
    console.log(err);
  }

};

return ( <div
   className="
   max-w-3xl
   mx-auto
 "
 >

  <h1
    className="
    text-3xl
    font-bold
    mb-6
  "
  >
    Edit Supplier
  </h1>

  <form
    onSubmit={submit}
    className="
    bg-[#111]
    p-6
    rounded-2xl
    space-y-5
  "
  >

    <input
      name="supplier_name"
      placeholder="Supplier Name"
      value={form.supplier_name || ""}
      onChange={handleChange}
      required
      className="
      w-full
      p-3
      rounded-xl
      bg-black
    "
    />

    <input
      name="phone"
      placeholder="Phone"
      value={form.phone || ""}
      onChange={handleChange}
      className="
      w-full
      p-3
      rounded-xl
      bg-black
    "
    />

    <input
      name="email"
      placeholder="Email"
      value={form.email || ""}
      onChange={handleChange}
      className="
      w-full
      p-3
      rounded-xl
      bg-black
    "
    />

    <input
      name="gst_no"
      placeholder="GST No"
      value={form.gst_no || ""}
      onChange={handleChange}
      className="
      w-full
      p-3
      rounded-xl
      bg-black
    "
    />

    <textarea
      name="address"
      rows="4"
      placeholder="Address"
      value={form.address || ""}
      onChange={handleChange}
      className="
      w-full
      p-3
      rounded-xl
      bg-black
    "
    />

    <select
      name="status"
      value={form.status}
      onChange={handleChange}
      className="
      w-full
      p-3
      rounded-xl
      bg-black
    "
    >
      <option value="1">
        Active
      </option>

      <option value="0">
        Inactive
      </option>
    </select>

    <button
      type="submit"
      className="
      px-6
      py-3
      bg-yellow-500
      text-black
      rounded-xl
      font-semibold
    "
    >
      Update Supplier
    </button>

  </form>

</div>

);
}

export default EditSupplier;
